(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/oddset/kambi-offering/assets/javascripts/sockets.js') >= 0) return;  svs.modules.push('/components/oddset/kambi-offering/assets/javascripts/sockets.js');
"use strict";

var _svs$oddset, _svs$oddset2;

const logger = svs.core.log.getLogger('components:oddset:kambi-offering:sockets');
const kambiPushApiUrl = (_svs$oddset = svs.oddset) === null || _svs$oddset === void 0 || (_svs$oddset = _svs$oddset.kambiOfferingApiUrl) === null || _svs$oddset === void 0 || (_svs$oddset = _svs$oddset.data) === null || _svs$oddset === void 0 ? void 0 : _svs$oddset.kambiPushApiUrl;
const kambiOfferingSocketChannelPrefix = (_svs$oddset2 = svs.oddset) === null || _svs$oddset2 === void 0 || (_svs$oddset2 = _svs$oddset2.kambiOfferingApiUrl) === null || _svs$oddset2 === void 0 || (_svs$oddset2 = _svs$oddset2.data) === null || _svs$oddset2 === void 0 ? void 0 : _svs$oddset2.kambiOfferingSocketChannelPrefix;
const normalizeSocketMessages = svs.components.oddset.kambiOffering.common.normalize.normalizeSocketMessages;
const LANGUAGE = 'sv';
const MAXIMUM_ATTEMPTS = 5;

const setupSockets = function (eventId, onMessageCallback) {
  let onSocketError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  if (!eventId) {
    throw new Error("Missing eventId. Not opening socket connection");
  }

  const socket = io(kambiPushApiUrl, {
    transports: ['websocket'],
    upgrade: false,
    autoConnect: false,
    path: '/socket.io'
  });
  socket.on('connect', () => {
    logger.debug('Socket connected');
  });
  socket.on('disconnect', reason => {
    logger.info("Socket disconnected: ".concat(reason));
  });
  socket.on('reconnect', attemptNumber => {
    logger.info("Socket reconnected after ".concat(attemptNumber, " attempts."));
  });
  socket.on('error', error => {
    const errorMsg = "Socket error: ".concat(error);
    logger.error(errorMsg);
    onSocketError(errorMsg);
  });
  socket.on('reconnect_attempt', attemptNumber => {
    logger.info("Socket reconnect attempt ".concat(attemptNumber));
    if (attemptNumber >= MAXIMUM_ATTEMPTS) {
      const errorMsg = "Closing socket after ".concat(attemptNumber, " reconnection attempts.");
      logger.error(errorMsg);
      onSocketError(errorMsg);
      socket.close();
    }
  });
  socket.on('message', incomingMessage => {
    const messages = JSON.parse(incomingMessage);
    onMessageCallback(normalizeSocketMessages(messages));
  });
  socket.open();
  const languageSpecificGeneralChannel = "".concat(kambiOfferingSocketChannelPrefix, ".").concat(LANGUAGE, ".ev.json");
  const nonLocalizedGeneralChannel = "".concat(kambiOfferingSocketChannelPrefix, ".ev.json");
  const languageSpecificChannel = "".concat(kambiOfferingSocketChannelPrefix, ".").concat(LANGUAGE, ".ev.").concat(eventId, ".json");
  const nonLocalizedChannel = "".concat(kambiOfferingSocketChannelPrefix, ".ev.").concat(eventId, ".json");
  const subscribe = () => {
    socket.emit('subscribe', {
      topic: languageSpecificGeneralChannel
    });
    socket.emit('subscribe', {
      topic: nonLocalizedGeneralChannel
    });
    socket.emit('subscribe', {
      topic: languageSpecificChannel
    });
    socket.emit('subscribe', {
      topic: nonLocalizedChannel
    });
  };
  const unsubscribe = () => {
    socket.emit('unsubscribe', {
      topic: languageSpecificGeneralChannel
    });
    socket.emit('unsubscribe', {
      topic: nonLocalizedGeneralChannel
    });
    socket.emit('unsubscribe', {
      topic: languageSpecificChannel
    });
    socket.emit('unsubscribe', {
      topic: nonLocalizedChannel
    });
  };
  return {
    subscribe,
    unsubscribe
  };
};
setGlobal('svs.components.oddset.kambiOffering.setupSockets', setupSockets);

 })(window);